import { defineStore } from 'pinia'
import { getTasks } from '@/services/source'
import { getInvites } from '~/services/talentImport'

const TASKS_CACHE_TTL_MS = 5 * 60 * 1000

export const useTasksStore = defineStore('tasks', {
  state: () => ({
    items: [],
    fetchedAt: null,
    fetchedScopeKey: null,
    hasFetched: false,
  }),
  getters: {
    hasInviteTask(state) {
      return state.items.some(task => task?.type === 'talent_import_invite')
    },
  },
  actions: {
    invalidateCache() {
      this.fetchedAt = null
      this.fetchedScopeKey = null
      this.hasFetched = false
    },
    async fetch({ force = false } = {}) {
      try {
        const clerkSessionStore = useClerkSessionStore()
        if (!clerkSessionStore.hasSession()) return

        const scopeKey = `${clerkSessionStore.sessionId || 'unknown'}`
        const cacheStillValid = this.hasFetched
          && this.fetchedAt
          && this.fetchedScopeKey === scopeKey
          && Date.now() - this.fetchedAt < TASKS_CACHE_TTL_MS

        if (!force && cacheStillValid) return this.items

        const tasks = await getTasks()
        if (!tasks) return

        const filteredTasks = tasks.filter(
          task => task?.type !== 'talent_import_invite',
        )
        const invites = await getInvites()
        if (!invites) return

        invites.forEach((invite) => {
          if (!invite.converted) {
            filteredTasks.push({
              name: `${invite.company.name} invited you!`,
              type: 'invite',
              icon: 'user-plus',
              ...invite,
            })
          }
        })

        this.items = filteredTasks
        this.fetchedAt = Date.now()
        this.fetchedScopeKey = scopeKey
        this.hasFetched = true
        return this.items
      }
      catch (e) {
        console.error('Failed to fetch invite', e)
        localStorage?.removeItem('talent_import')
        return this.items
      }
    },
  },
})
